module.exports = __webpack_public_path__ + "static/media/player_level_B.e7d3b67e.png";